export default __webpack_public_path__ + "static/style4.1_Blonde-15a5fd4e3d4ff7b72bb51f36b9a974e4.wav";